export class DialogModelSendExpiryItemToDn {
    constructor(
      public item: any
    ) {}
  }
  